import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from 'routes';
import { INACTIVITY_TIMEOUT } from 'constants/global';

const STOP_TIMERS_PATHS = [ROUTE_PATH.GESTOPAGO];

const UserInactivity = ({ path }) => {
  const time = useRef(0);
  const pathRef = useRef(path);
  const timeoutRef = useRef(null);
  const intervalRef = useRef(null);
  const navigate = useNavigate();

  const redirectToInactiveSession = () => {
    navigate(ROUTE_PATH.INACTIVE_SESSION);
  };

  const stopTimers = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    if (intervalRef.current) {
      clearInterval(intervalRef.current);
    }
  };

  const resetTimer = () => {
    stopTimers();
    if (!STOP_TIMERS_PATHS.includes(pathRef.current)) {
      time.current = new Date().getTime();
      timeoutRef.current = setTimeout(redirectToInactiveSession, INACTIVITY_TIMEOUT);

      // Si se queda en segundo plano los timeout se pierden, por lo que se usa un intervalo para comprobar el tiempo real
      intervalRef.current = setInterval(() => {
        const leftTime = INACTIVITY_TIMEOUT - (new Date().getTime() - time.current);
        if (leftTime <= 0) {
          clearInterval(intervalRef.current);
          redirectToInactiveSession();
        }
      }, Math.floor(INACTIVITY_TIMEOUT / 10));
    }
  };

  useEffect(() => {
    pathRef.current = path;
    if (STOP_TIMERS_PATHS.includes(path)) {
      stopTimers();
    } else {
      resetTimer();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  useEffect(() => {
    const events = ['keypress', 'scroll', 'touchstart'];
    const handleUserActivity = () => {
      resetTimer();
    };

    events.forEach((event) => {
      window.addEventListener(event, handleUserActivity, { passive: true });
    });

    resetTimer();

    return () => {
      stopTimers();
      events.forEach((event) => {
        window.removeEventListener(event, handleUserActivity);
      });
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return null;
};

UserInactivity.propTypes = {
  path: PropTypes.string.isRequired,
};

export default UserInactivity;
